import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="h-screen flex bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col ml-16">
        <Header />
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-6">
            {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
